module.exports = __webpack_public_path__ + "img/logo.8227a872.svg";